import type { ApplicationResult, Question, Stage } from './results-table';

import { i18n } from '~/lib/i18n';
import { formatDate } from '~/utils/date';

export function generateCsv(
  results: ApplicationResult[],
  stages: Stage[],
  questions: Question[],
  jobTitle: string
): string {
  const stageMap = new Map(stages.map((s) => [s.id, s.name]));
  const t = i18n.t.bind(i18n);
  const fixedHeaders = [
    t('results.csv.headers.candidateName'),
    t('results.csv.headers.email'),
    t('results.csv.headers.role'),
    t('results.csv.headers.stage'),
    t('results.csv.headers.overallScore'),
    t('results.csv.headers.recommendation'),
    t('results.csv.headers.eligibility'),
    t('results.csv.headers.expectations'),
    t('results.csv.headers.avgScore'),
    t('results.csv.headers.interviewDate'),
    t('results.csv.headers.status')
  ];
  const headers = [...fixedHeaders, ...questions.map((q) => q.text)];
  const rows = results.map((r) => {
    const scoreMap = new Map(r.questionScores.map((qs) => [qs.questionId, qs]));
    const fixedCols = [
      r.candidateName,
      r.candidateEmail,
      jobTitle,
      stageMap.get(r.stageId) ?? r.stageId,
      r.overallScore?.toString() ?? '',
      r.recommendation ?? '',
      r.eligibilityPassed ?? '',
      r.expectationsPassed ?? '',
      r.assessmentAverage ?? '',
      r.scoredAt ? formatDate(r.scoredAt) : '',
      r.scoreStatus ?? 'no_interview'
    ];
    const questionCols = questions.map((q) => {
      const qs = scoreMap.get(q.id);
      if (!qs) return '';
      return qs.reasoning;
    });
    return [...fixedCols, ...questionCols];
  });
  const escape = (val: string): string =>
    val.includes(',') || val.includes('"') || val.includes('\n')
      ? `"${val.replace(/"/g, '""')}"`
      : val;
  return [headers, ...rows].map((row) => row.map(escape).join(',')).join('\n');
}
